import { render, staticRenderFns } from "./XBtn.vue?vue&type=template&id=53de4dc1&"
import script from "./XBtn.vue?vue&type=script&lang=ts&"
export * from "./XBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../tbestpro-management/admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports